import Draggable from '@components/DragAndDrop/components/Draggable/Draggable';
import { DraggableItemIds } from '@components/DragAndDrop/components/draggableItemIds';
import { WebphoneCallState } from '@modules/SoftPhoneModule/types';
import { useWindowSize } from 'usehooks-ts';
import CallControls from './components/CallControls';
import { useCallBarProps } from './hooks/useCallBarProps';

const CALL_CONTROLS_WIDTH_PX = 777;
const CALL_CONTROLS_BOTTOM_OFFSET = 24;

interface DraggableCallBarProps {
  callState: WebphoneCallState;
  show: boolean;
}

export function DraggableCallBar({
  callState,
  show,
}: Readonly<DraggableCallBarProps>) {
  const callBarProps = useCallBarProps(callState, show);
  const { width: windowWidth } = useWindowSize();

  const handleCalculateAbsolutePosition = (x: number, y: number) => ({
    bottom: `${CALL_CONTROLS_BOTTOM_OFFSET - y}px`,
    left: windowWidth / 2 - CALL_CONTROLS_WIDTH_PX / 2 + x,
  });

  if (!callBarProps) {
    return null;
  }

  return (
    <Draggable
      id={`${DraggableItemIds.CALL_CONTROLS}-${callBarProps.callId}`}
      calculateAbsolutePosition={handleCalculateAbsolutePosition}
    >
      <CallControls pinned={false} {...callBarProps} />
    </Draggable>
  );
}
